export const capabilityTermProfiles: Record<
  string,
  {
    colors: number;
    mouse: boolean;
    altScreen: boolean;
    unicode: boolean;
    description: string;
  }
> = {
  'xterm-256color': {
    colors: 256,
    mouse: true,
    altScreen: true,
    unicode: true,
    description: 'Modern terminal with 256-color support',
  },
  xterm: {
    colors: 16,
    mouse: true,
    altScreen: true,
    unicode: true,
    description: 'Standard X terminal emulator',
  },
  'screen-256color': {
    colors: 256,
    mouse: true,
    altScreen: true,
    unicode: true,
    description: 'GNU Screen with 256 colors',
  },
  vt100: {
    colors: 0,
    mouse: false,
    altScreen: false,
    unicode: false,
    description: 'DEC terminal from 1978',
  },
  dumb: {
    colors: 0,
    mouse: false,
    altScreen: false,
    unicode: false,
    description: 'No special capabilities',
  },
};

export const capabilityFeatures = [
  {
    id: 'mouse',
    name: 'Mouse Tracking',
    enable: '^[[?1000h',
    disable: '^[[?1000l',
    description: 'Report mouse clicks as escape sequences',
  },
  {
    id: 'altscreen',
    name: 'Alternate Screen',
    enable: '^[[?1049h',
    disable: '^[[?1049l',
    description: 'Switch to a separate screen buffer',
  },
  {
    id: 'bracketed',
    name: 'Bracketed Paste',
    enable: '^[[?2004h',
    disable: '^[[?2004l',
    description: 'Wrap pasted text with special markers',
  },
];

export const capabilityDa1Codes: Record<string, string> = {
  '1': '132 columns',
  '2': 'Printer port',
  '4': 'Sixel graphics',
  '6': 'Selective erase',
  '7': 'Soft fonts (DRCS)',
  '8': 'User-defined keys',
  '9': 'National replacement sets',
  '15': 'Technical character set',
  '18': 'Windowing capability',
  '21': 'Horizontal scrolling',
  '22': 'ANSI color',
  '28': 'Rectangular editing',
  '29': 'ANSI text locator',
};

export const capabilityDiscoveryUi = {
  termSubsection: 'The TERM Variable',
  capabilityLabels: {
    colors: 'Colors',
    mouse: 'Mouse',
    altScreen: 'Alt Screen',
    unicode: 'Unicode',
    none: 'None',
    yes: 'Yes',
    no: 'No',
  },
  termExplanationBefore: 'Programs check the ',
  termVarName: 'TERM',
  termExplanationAfter:
    ' environment variable to look up capabilities in the terminfo database. It\'s just a string—the terminal doesn\'t enforce it.',
  querySubsection: 'Query & Response',
  programLabel: 'Program',
  terminalLabel: 'Terminal',
  responseDecoded: 'Response Decoded',
  querySending: 'Sending...',
  queryReceiving: 'Receiving...',
  querySendAgain: 'Send Again',
  queryIdle: 'Send DA1 Query',
  queryExplanationBefore: 'Programs can also query the terminal directly. DA1 (',
  queryDa1Code: 'ESC[c',
  queryExplanationAfter:
    ') asks "what are you?" and the terminal responds with capability codes.',
  queryEscOutgoing: 'ESC[c',
  queryEscResponse: 'ESC[?64;1;4;22c',
  featuresSubsection: 'Enabling Features',
  featuresFooterBefore:
    'Features are off by default. Programs send escape sequences to enable them—that\'s why vim sends ',
  featuresFooterEnableSeq: '^[[?1049h',
  featuresFooterMid: ' at startup (to enter alternate screen) and ',
  featuresFooterDisableSeq: '^[[?1049l',
  featuresFooterAfter: ' when you quit.',
} as const;
